import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { Accordion, AccordionItem } from '../candidates/components/Accordion'

import UserDataContent from './components/UserDataContent'
import UIStaightlineProressBar from '../../components/UI/UIStaightlineProressBar'
import { CircularProgressbar } from 'react-circular-progressbar'
import { User } from './apiCalls'
import { calculateNonNullPercentage, formatDate } from '../../utils/utils'
import UiSelect from '../../components/UI/UISelect'
import UITextInput from '../../components/UI/UITextInput'
import UIDatePickerv from '../../components/UI/UIDatePickerv'
import UIButton from '../../components/UI/UIButton'
import {
  employmentDetails,
  UserEmploymentData,
  UserEmploymentDetailsData,
} from '../../utils/types'
import { toast } from 'react-toastify'
import { updateUserEmployment } from '../../api/lead/scr'

const Employment = ({
  data,
  scrRecordRefetch,
  setIsEdit,
  isEdit,
}: {
  scrRecordRefetch?: () => void
  data?: User
  isEdit: boolean
  setIsEdit: Dispatch<SetStateAction<boolean>>
}) => {
  const [isUpdateLoading, setIsUpdateLoading] = useState<boolean>(false)
  const [userData, setUserData] = useState<UserEmploymentData>()
  const CurrentEmploymentDetailsCotent: { [key: string]: string }[] = [
    { 'Job Title': data?.EmploymentDetails[2]?.jobTitle || '' },
    { Department: data?.EmploymentDetails[2]?.department || '' },
    { 'Start Date': formatDate(data?.EmploymentDetails[2]?.startDate || '') },
    // { 'End Date': formatDate(data?.EmploymentDetails[2]?.endDate || '') },
    { 'Work Status': data?.EmploymentDetails[2]?.workStatus || '' },
  ]
  const EmploymentDetailsCotent: { [key: string]: string }[] = [
    { 'Job Title': data?.EmploymentDetails[0]?.jobTitle || '' },
    { Department: data?.EmploymentDetails[0]?.department || '' },
    { 'Start Date': formatDate(data?.EmploymentDetails[0]?.startDate || '') },
    { 'End Date': formatDate(data?.EmploymentDetails[0]?.endDate || '') },
    { 'Work Status': data?.EmploymentDetails[0]?.workStatus || '' },
  ]

  const PreviousEmploymentDetailsCotent: { [key: string]: string }[] = [
    { 'Job Title': data?.EmploymentDetails[1]?.jobTitle || '' },
    { Department: data?.EmploymentDetails[1]?.department || '' },
    { 'Start Date': formatDate(data?.EmploymentDetails[1]?.startDate || '') },
    { 'End Date': formatDate(data?.EmploymentDetails[1]?.endDate || '') },
    { 'Work Status': data?.EmploymentDetails[1]?.workStatus || '' },
  ]

  useEffect(() => {
    setUserData({
      employmentDetails: [
        {
          jobTitle: data?.EmploymentDetails[0]?.jobTitle || '',
          department: data?.EmploymentDetails[0]?.department || undefined,
          startDate: data?.EmploymentDetails[0]?.startDate || '',
          endDate: data?.EmploymentDetails[0]?.endDate || '',
          workStatus: data?.EmploymentDetails[0]?.workStatus || undefined,
        },
        {
          jobTitle: data?.EmploymentDetails[1]?.jobTitle || '',
          department: data?.EmploymentDetails[1]?.department || undefined,
          startDate: data?.EmploymentDetails[1]?.startDate || '',
          endDate: data?.EmploymentDetails[1]?.endDate || '',
          workStatus: data?.EmploymentDetails[1]?.workStatus || undefined,
        },
        {
          jobTitle: data?.EmploymentDetails[2]?.jobTitle || '',
          department: data?.EmploymentDetails[2]?.department || undefined,
          startDate: data?.EmploymentDetails[2]?.startDate || '',
          endDate: data?.EmploymentDetails[2]?.endDate || '',
          workStatus: data?.EmploymentDetails[2]?.workStatus || undefined,
        },
      ],
    })
  }, [data])

  const handleChange = (
    objNo: number,
    fieldName: keyof employmentDetails,
    value: string
  ) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setUserData((prevUserData: any) => {
      const employmentDetails = prevUserData?.employmentDetails?.map(
        (obj: UserEmploymentDetailsData, index: number) => {
          if (index === objNo - 1) {
            return { ...obj, [fieldName]: value }
          }
          return obj
        }
      )
      return { ...prevUserData, employmentDetails }
    })
  }

  const updateEmploymentData = async (): Promise<void> => {
    setIsUpdateLoading(true)
    if (userData) {
      try {
        const response = (await updateUserEmployment(
          userData,
          data?.schoolId || '',
          data?.userId
        )) as {
          status?: string
          data: UserEmploymentData
        }

        if (response?.status == 'successful') {
          scrRecordRefetch && scrRecordRefetch()
          setIsEdit(false)
          toast.success('Profile Updated.', {
            position: 'top-right',
          })
        } else {
          toast.error('Network Error.', {
            position: 'top-right',
          })
        }
      } catch (error) {
        toast.error('Network Error.', { position: 'top-right' })
      } finally {
        setIsUpdateLoading(false)
      }
    }
  }

  return (
    <div
      style={{
        height: 'calc(100vh - 100px)',
        overflow: 'auto',
        scrollbarWidth: 'none',
      }}
    >
      <div className="flex my-8 gap-2">
        {/* First column */}
        <div
          style={{
            height: 'calc(100vh - 100px)',
            overflow: 'auto',
            scrollbarWidth: 'none',
          }}
          className="flex flex-col w-8/12 gap-4"
        >
          {isEdit ? (
            <>
              <Accordion defaultActiveIndex={0}>
                <AccordionItem
                  onClick={() => console.log('Accordion')}
                  title={'Current Employment Details'}
                  isActive={false}
                >
                  <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                    <div className="flex w-full gap-4">
                      <div className="w-6/12  ">
                        <UITextInput
                          placeholder={'Job Title'}
                          label={'Job Title'}
                          iconName={''}
                          value={
                            userData && userData?.employmentDetails[2]?.jobTitle
                          }
                          onChange={(e) => {
                            handleChange(3, 'jobTitle', e.target.value)
                          }}
                        />
                      </div>
                      <div className="w-6/12">
                        <UITextInput
                          placeholder={'Department'}
                          label={'Department'}
                          iconName={''}
                          value={
                            userData &&
                            userData?.employmentDetails[2]?.department
                          }
                          onChange={(e) => {
                            handleChange(3, 'department', e.target.value)
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex w-full gap-4">
                      <div className="w-6/12 ">
                        <UIDatePickerv
                          placeholderText={'Not Specified'}
                          title={'Start Date'}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleChange(3, 'startDate', e.target.value)
                          }}
                          value={
                            userData &&
                            userData?.employmentDetails[2]?.startDate
                          }
                        />
                      </div>
                    </div>
                    <div className="flex w-full">
                      <div className="w-6/12">
                        <UiSelect
                          onChange={(e: string) => {
                            handleChange(3, 'workStatus', e)
                          }}
                          value={
                            userData &&
                            userData?.employmentDetails[2]?.workStatus
                          }
                          options={[
                            { value: 'Full Time', label: 'Full Time' },
                            { value: 'Part Time', label: 'Part Time' },
                            { value: 'Term Time', label: 'Term Time' },
                            { value: 'Job Share', label: 'Job Share' },
                            { value: 'Casual', label: 'Casual' },
                            { value: 'Agency', label: 'Agency' },
                            { value: 'Contract', label: 'Contract' },
                          ]}
                          title={'Work Status'}
                        />
                      </div>
                    </div>
                  </div>
                </AccordionItem>
              </Accordion>
              <Accordion defaultActiveIndex={0}>
                <AccordionItem
                  onClick={() => console.log('Accordion')}
                  title={'Previous Employment Details 1'}
                  isActive={false}
                >
                  <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                    <div className="flex w-full gap-4">
                      <div className="w-6/12  ">
                        <UITextInput
                          placeholder={'Job Title'}
                          label={'Job Title'}
                          iconName={''}
                          value={
                            userData && userData?.employmentDetails[0]?.jobTitle
                          }
                          onChange={(e) => {
                            handleChange(1, 'jobTitle', e.target.value)
                          }}
                        />
                      </div>
                      <div className="w-6/12">
                        <UITextInput
                          placeholder={'Department'}
                          label={'Department'}
                          iconName={''}
                          value={
                            userData &&
                            userData?.employmentDetails[0]?.department
                          }
                          onChange={(e) => {
                            handleChange(1, 'department', e.target.value)
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex w-full gap-4">
                      <div className="w-6/12 ">
                        <UIDatePickerv
                          placeholderText={'Not Specified'}
                          title={'Start Date'}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleChange(1, 'startDate', e.target.value)
                          }}
                          value={
                            userData &&
                            userData?.employmentDetails[0]?.startDate
                          }
                        />
                      </div>
                      <div className="w-6/12">
                        <UIDatePickerv
                          placeholderText={'Not Specified'}
                          title={'End Date'}
                          value={
                            userData && userData?.employmentDetails[0]?.endDate
                          }
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleChange(1, 'endDate', e.target.value)
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex w-full">
                      <div className="w-6/12">
                        <UiSelect
                          onChange={(e: string) => {
                            handleChange(1, 'workStatus', e)
                          }}
                          value={
                            userData &&
                            userData?.employmentDetails[0]?.workStatus
                          }
                          options={[
                            { value: 'Full Time', label: 'Full Time' },
                            { value: 'Part Time', label: 'Part Time' },
                            { value: 'Term Time', label: 'Term Time' },
                            { value: 'Job Share', label: 'Job Share' },
                            { value: 'Casual', label: 'Casual' },
                            { value: 'Agency', label: 'Agency' },
                            { value: 'Contract', label: 'Contract' },
                          ]}
                          title={'Work Status'}
                        />
                      </div>
                    </div>
                  </div>
                </AccordionItem>
              </Accordion>
              <Accordion defaultActiveIndex={0}>
                <AccordionItem
                  onClick={() => console.log('Accordion')}
                  title={'Previous Employment Details 2'}
                  isActive={false}
                >
                  <div className="flex flex-col gap-4 mt-2 my-4 px-2">
                    <div className="flex w-full gap-4">
                      <div className="w-6/12  ">
                        <UITextInput
                          placeholder={'Job Title'}
                          label={'Job Title'}
                          iconName={''}
                          value={
                            userData && userData?.employmentDetails[1]?.jobTitle
                          }
                          onChange={(e) => {
                            handleChange(2, 'jobTitle', e.target.value)
                          }}
                        />
                      </div>
                      <div className="w-6/12">
                        <UITextInput
                          placeholder={'Department'}
                          label={'Department'}
                          iconName={''}
                          value={
                            userData &&
                            userData?.employmentDetails[1]?.department
                          }
                          onChange={(e) => {
                            handleChange(2, 'department', e.target.value)
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex w-full gap-4">
                      <div className="w-6/12 ">
                        <UIDatePickerv
                          placeholderText={'Not Specified'}
                          title={'Start Date'}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleChange(2, 'startDate', e.target.value)
                          }}
                          value={
                            userData &&
                            userData?.employmentDetails[1]?.startDate
                          }
                        />
                      </div>
                      <div className="w-6/12">
                        <UIDatePickerv
                          placeholderText={'Not Specified'}
                          title={'End Date'}
                          value={
                            userData && userData?.employmentDetails[1]?.endDate
                          }
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            handleChange(2, 'endDate', e.target.value)
                          }}
                        />
                      </div>
                    </div>
                    <div className="flex w-full">
                      <div className="w-6/12">
                        <UiSelect
                          onChange={(e: string) => {
                            handleChange(2, 'workStatus', e)
                          }}
                          value={
                            userData &&
                            userData?.employmentDetails[1]?.workStatus
                          }
                          options={[
                            { value: 'Full Time', label: 'Full Time' },
                            { value: 'Part Time', label: 'Part Time' },
                            { value: 'Term Time', label: 'Term Time' },
                            { value: 'Job Share', label: 'Job Share' },
                            { value: 'Casual', label: 'Casual' },
                            { value: 'Agency', label: 'Agency' },
                            { value: 'Contract', label: 'Contract' },
                          ]}
                          title={'Work Status'}
                        />
                      </div>
                    </div>
                  </div>
                </AccordionItem>
              </Accordion>
              <div className="w-[33%] mt-6">
                <UIButton
                  onClick={updateEmploymentData}
                  loading={isUpdateLoading}
                  label="Update"
                />
              </div>
            </>
          ) : (
            <>
              <Accordion defaultActiveIndex={0}>
                <AccordionItem
                  onClick={() => console.log('Accordion')}
                  title={'Current Employment Details'}
                  isActive={false}
                >
                  <div className="flex flex-col mt-2 my-4 px-2">
                    <UserDataContent content={CurrentEmploymentDetailsCotent} />
                  </div>
                </AccordionItem>
              </Accordion>
              <Accordion defaultActiveIndex={0}>
                <AccordionItem
                  onClick={() => console.log('Accordion')}
                  title={'Previous Employment Details 1'}
                  isActive={false}
                >
                  <div className="flex flex-col mt-2 my-4 px-2">
                    <UserDataContent content={EmploymentDetailsCotent} />
                  </div>
                </AccordionItem>
              </Accordion>
              <Accordion defaultActiveIndex={0}>
                <AccordionItem
                  onClick={() => console.log('Accordion')}
                  title={'Previous Employment Details 2'}
                  isActive={false}
                >
                  <div className="flex flex-col mt-2 my-4 px-2">
                    <UserDataContent
                      content={PreviousEmploymentDetailsCotent}
                    />
                  </div>
                </AccordionItem>
              </Accordion>
            </>
          )}
        </div>

        {/* Second column */}
        <div className="w-4/12">
          <Accordion defaultActiveIndex={0}>
            <AccordionItem
              onClick={() => console.log('Accordion')}
              title={'Scorecard'}
              isActive={true}
              AccordionItemStyle={{
                backgroundColor: 'rgba(230, 240, 243, 1)',
              }}
              AccordiontitleStyle={
                'text-sm font-semibold text-bluishGreen leading-6'
              }
              AccordionItemStyleContainer={{
                backgroundColor: 'rgba(242, 247, 249, 1)',
              }}
              icon={'IconBarChartSquare'}
            >
              <div className="bg-gray1 flex items-center flex-col justify-center gap-4 my-8">
                <div className="w-[160px] h-[160px]">
                  <CircularProgressbar
                    strokeWidth={5}
                    value={
                      calculateNonNullPercentage([
                        data?.EmploymentDetails[0]?.jobTitle,
                        data?.EmploymentDetails[0]?.department,
                        data?.EmploymentDetails[0]?.startDate,
                        data?.EmploymentDetails[0]?.endDate,
                        data?.EmploymentDetails[0]?.workStatus,

                        data?.EmploymentDetails[1]?.jobTitle,
                        data?.EmploymentDetails[1]?.department,
                        data?.EmploymentDetails[1]?.startDate,
                        data?.EmploymentDetails[1]?.endDate,
                        data?.EmploymentDetails[1]?.workStatus,
                        data?.EmploymentDetails[2]?.jobTitle,
                        data?.EmploymentDetails[2]?.department,
                        data?.EmploymentDetails[2]?.startDate,

                        data?.EmploymentDetails[2]?.workStatus,
                      ]).percentage
                    }
                    text={`${
                      calculateNonNullPercentage([
                        data?.EmploymentDetails[0]?.jobTitle,
                        data?.EmploymentDetails[0]?.department,
                        data?.EmploymentDetails[0]?.startDate,
                        data?.EmploymentDetails[0]?.endDate,
                        data?.EmploymentDetails[0]?.workStatus,

                        data?.EmploymentDetails[1]?.jobTitle,
                        data?.EmploymentDetails[1]?.department,
                        data?.EmploymentDetails[1]?.startDate,
                        data?.EmploymentDetails[1]?.endDate,
                        data?.EmploymentDetails[1]?.workStatus,
                        data?.EmploymentDetails[2]?.jobTitle,
                        data?.EmploymentDetails[2]?.department,
                        data?.EmploymentDetails[2]?.startDate,

                        data?.EmploymentDetails[2]?.workStatus,
                      ]).percentage
                    }%`}
                    styles={{
                      root: {},
                      path: {
                        stroke: calculateNonNullPercentage([
                          data?.EmploymentDetails[0]?.jobTitle,
                          data?.EmploymentDetails[0]?.department,
                          data?.EmploymentDetails[0]?.startDate,
                          data?.EmploymentDetails[0]?.endDate,
                          data?.EmploymentDetails[0]?.workStatus,

                          data?.EmploymentDetails[1]?.jobTitle,
                          data?.EmploymentDetails[1]?.department,
                          data?.EmploymentDetails[1]?.startDate,
                          data?.EmploymentDetails[1]?.endDate,
                          data?.EmploymentDetails[1]?.workStatus,
                        ]).color,
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                      },
                      text: {
                        fill: '#013546',
                        fontSize: '24px',
                        fontWeight: 700,
                        lineHeight: 40,
                      },
                    }}
                  />
                </div>
                <div className="w-full bg-white flex flex-col gap-4 my-4 px-4 py-4 rounded-xl">
                  <div className="mt-3">
                    <UIStaightlineProressBar
                      percentage={
                        calculateNonNullPercentage([
                          data?.EmploymentDetails[2]?.jobTitle,
                          data?.EmploymentDetails[2]?.department,
                          data?.EmploymentDetails[2]?.startDate,

                          data?.EmploymentDetails[2]?.workStatus,
                        ]).percentage
                      }
                      label={'Current Employment Details'}
                      stroke={
                        calculateNonNullPercentage([
                          data?.EmploymentDetails[2]?.jobTitle,
                          data?.EmploymentDetails[2]?.department,
                          data?.EmploymentDetails[2]?.startDate,

                          data?.EmploymentDetails[2]?.workStatus,
                        ]).color
                      }
                      strokeWidth={1.5}
                    />
                  </div>
                  <div className="mt-3">
                    <UIStaightlineProressBar
                      percentage={
                        calculateNonNullPercentage([
                          data?.EmploymentDetails[0]?.jobTitle,
                          data?.EmploymentDetails[0]?.department,
                          data?.EmploymentDetails[0]?.startDate,
                          data?.EmploymentDetails[0]?.endDate,
                          data?.EmploymentDetails[0]?.workStatus,
                        ]).percentage
                      }
                      label={'Previous Employment Details 1'}
                      stroke={
                        calculateNonNullPercentage([
                          data?.EmploymentDetails[0]?.jobTitle,
                          data?.EmploymentDetails[0]?.department,
                          data?.EmploymentDetails[0]?.startDate,
                          data?.EmploymentDetails[0]?.endDate,
                          data?.EmploymentDetails[0]?.workStatus,
                        ]).color
                      }
                      strokeWidth={1.5}
                    />
                  </div>
                  <div className="mt-3">
                    <UIStaightlineProressBar
                      percentage={
                        calculateNonNullPercentage([
                          data?.EmploymentDetails[1]?.jobTitle,
                          data?.EmploymentDetails[1]?.department,
                          data?.EmploymentDetails[1]?.startDate,
                          data?.EmploymentDetails[1]?.endDate,
                          data?.EmploymentDetails[1]?.workStatus,
                        ]).percentage
                      }
                      label={'Previous Employment Details 2'}
                      stroke={
                        calculateNonNullPercentage([
                          data?.EmploymentDetails[1]?.jobTitle,
                          data?.EmploymentDetails[1]?.department,
                          data?.EmploymentDetails[1]?.startDate,
                          data?.EmploymentDetails[1]?.endDate,
                          data?.EmploymentDetails[1]?.workStatus,
                        ]).color
                      }
                      strokeWidth={1.5}
                    />
                  </div>
                </div>
              </div>
            </AccordionItem>
          </Accordion>
        </div>
      </div>
    </div>
  )
}

export default Employment
